import type * as React from 'react';
import { put } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import userUpdated, { type UserUpdatedAction } from '@Application/Users/Users/Actions/userUpdated';
import userUpdateFailed, {
	type UserUpdateFailedAction,
} from '@Application/Users/Users/Actions/userUpdateFailed';
import type UpdateUser from '@Application/Users/Users/Commands/UpdateUser';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserUpdatedAction | UserUpdateFailedAction;

export default (command: UpdateUser) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}`,
				command.toJSON(),
			);

			const action = userUpdated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
